'use client';

import type { UserPlayerResponse } from '@1webit/cvs-api-scheme';
import Image from 'next/image';
import Link from 'next/link';

import { generatePlayerImageUrl } from '@/utils';

interface Props {
  player: UserPlayerResponse;
  onHide: () => void;
}

export const PlayerSwiperItem = (props: Props) => {
  const {
    player,
    onHide,
  } = props;

  return (
    <Link
      href={`/registration/${player.id}`}
      onClick={onHide}
      className="cursor-pointer"
    >
      <div>
        <div className="relative flex h-52 items-center justify-center p-6">
          <div className="absolute bottom-0 left-0 h-5/6 w-full rounded-t-md bg-gray-100 shadow-sm" />

          <Image
            src={generatePlayerImageUrl(player.id)}
            alt="Profilový obrázek"
            fill
            className="object-cover"
          />
        </div>

        <div className="mt-3 flex justify-between gap-1 text-sm">
          <span className="font-semibold text-blue-600">
            {player.firstName}
            {' '}
            {player.lastName}
          </span>
          <span className="text-red-500">{player?.dateOfBirth?.split('-')?.[0]}</span>
        </div>
      </div>
    </Link>
  );
};
